<div class="container-fluid">
  <div class="row">
    <!-- <div
      class="col-xl-7 rounded-end-5"
      [ngStyle]="{
        'background-image': 'url(assets/images/login/login_splash.jpg)',
        'background-size': 'cover',
        'background-position': 'center center',
        display: 'block'
      }"
    >
      <img
        class="bg-img-cover bg-center d-none"
        src="assets/images/login/login_splash.jpg"
        alt="looginpage"
      />
    </div> -->
    <div class="col-xl-5 p-0" style="width: 100%;">
      <div class="login-card login-dark">
        <div>
          <div class="logo text-center">
            <img
              class="img-fluid for-light"
              src="assets/images/logo/logo.png"
              alt="looginpage"
              width="300"
            />
            <img
              class="img-fluid for-dark"
              src="assets/images/logo/logo_dark.png"
              alt="looginpage"
            />
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4 class="innoku-color">{{ "SignInToAccount" | translate }}</h4>
              <p>{{ "SignInInfo" | translate }}</p>
              <div class="form-group">
                <label class="col-form-label">{{
                  "EmailAddress" | translate
                }}</label>
                <input
                  class="form-control"
                  type="email"
                  required=""
                  [placeholder]="'SignInUserNamePlaceholder' | translate"
                  formControlName="email"
                />
                <div
                  *ngIf="
                    loginForm.controls.email.touched &&
                    loginForm.controls.email.errors?.required
                  "
                  class="text text-danger mt-1"
                >
                  Email is required
                </div>
                <div
                  *ngIf="
                    loginForm.controls.email.touched &&
                    loginForm.controls.email.errors?.email
                  "
                  class="text text-danger mt-1"
                >
                  Invalid Email
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">{{
                  "Password" | translate
                }}</label>
                <input
                  class="form-control"
                  [type]="show ? 'text' : 'password'"
                  formControlName="password"
                  required=""
                  placeholder="*********"
                  (keydown.enter)="login()"
                />
                <div class="show-hide" (click)="showPassword()" *ngIf="!show">
                  <span class="show"></span>
                </div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show">
                  <span class="Hide"></span>
                </div>
                <div
                  *ngIf="
                    loginForm.controls.password.touched &&
                    loginForm.controls.password.errors?.required
                  "
                  class="text text-danger mt-1"
                >
                  Password is required
                </div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox" />
                  <label for="checkbox1">{{
                    "RememberPassword" | translate
                  }}</label>
                </div>
                <a
                  [routerLink]="'/auth/password-reset'"
                  class="link innoku-color"
                  >{{ "ForgotPassword" | translate }}</a
                >
                <div class="text-end mt-3">
                  <button
                    class="btn btn-primary-innoku d-block w-100"
                    [disabled]="!loginForm.valid"
                    (click)="login()"
                    type="button"
                  >
                    <span>{{ "SignIn" | translate }} <span class="spinner-border spinner-border-sm" *ngIf="loading"></span></span>
                  </button>
                </div>
              </div>
              <!-- <h6 class="text-muted mt-4 or">Or Sign in with</h6> -->
              <!-- <div class="social mt-4">
                <div class="btn-showcase">
                  <a class="btn btn-light" target="_blank"><app-feather-icons [icon]="'txt-google'"></app-feather-icons> Google + </a>
                  <a class="btn btn-light" target="_blank"><app-feather-icons [icon]="'facebook'"></app-feather-icons> Facebook </a>
                  <a class="btn btn-light" target="_blank"><app-feather-icons [icon]="'twitter'"></app-feather-icons> twitter </a>
                </div>
              </div> -->
              <p class="mt-4 mb-0">
                {{ "DontHaveAccount" | translate }}
                <a
                  [routerLink]="'/auth/sign-up'"
                  class="ms-2 innoku-color"
                  >{{ "CreateAccount" | translate }}</a
                >
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
